
import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";

const data = [
  { name: "Work", value: 45.8, color: "#0088FE" },
  { name: "Eat", value: 8.3, color: "#00C49F" },
  { name: "Commute", value: 8.3, color: "#FFBB28" },
  { name: "Watch TV", value: 8.3, color: "#FF8042" },
  { name: "Sleep", value: 29.2, color: "#FF4444" },
];

const DonutChart = () => {
  return (
    <ResponsiveContainer width="100%" height={400}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={100}
          fill="#8884d8"
          paddingAngle={5}
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default DonutChart;
